export const inboxAppUrl = {
	cpURL: process.env.REACT_APP_URL
}

export const accountAppUrl = {
	cpURL: process.env.REACT_APP_ACCOUNT_CP_URL
}
